import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-16">
      <div className="max-w-[1100px] mx-auto px-8 lg:px-14" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="mb-20 lg:mb-24" data-id="element-18">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-19">
            <span className="w-10 h-px bg-caramel/40" data-id="element-20" />
            {t.faq.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-21">
            {t.faq.title1}
            <br data-id="element-22" />
            <span className="italic font-extralight" data-id="element-23">{t.faq.title2}</span>
          </h2>
        </motion.div>

        <div className="border-t border-cream/15" data-id="element-24">
          {t.faq.items.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-cream/15" data-id="element-25">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-baseline justify-between gap-8 py-8 lg:py-10 text-left group" data-id="element-26">
                  <div className="flex items-baseline gap-6 lg:gap-10" data-id="element-27">
                    <span className="font-serif italic text-caramel text-sm" data-id="element-28">
                      0{i + 1}
                    </span>
                    <span className={`font-serif text-2xl lg:text-3xl text-cream font-light tracking-[-0.01em] transition-all duration-500 ${isOpen ? 'italic' : 'group-hover:italic'}`} data-id="element-29">
                      {f.q}
                    </span>
                  </div>
                  <span className={`relative w-3 h-3 shrink-0 mt-3 transition-transform duration-500 ${isOpen ? 'rotate-45' : ''}`} data-id="element-30">
                    <span className="absolute top-1/2 left-0 right-0 h-px bg-cream" data-id="element-31" />
                    <span className="absolute left-1/2 top-0 bottom-0 w-px bg-cream" data-id="element-32" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-33">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-34">
                      <p className="pb-10 pl-10 lg:pl-16 pr-10 text-cream/60 leading-[1.8] text-[15px] max-w-2xl" data-id="element-35">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}